import { isoWeekOf } from "@/components/weeks";

const pad = (n) => String(n).padStart(2, "0");
export const toYmd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const fromYmd = (s) => { const [y, m, d] = s.split("-").map(Number); return new Date(y, m - 1, d); };

const today = () => { const n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate()); };

export function latestSunday(from = today()) {
  const d = new Date(from);
  d.setDate(d.getDate() - d.getDay());
  return d;
}

// 1st of the month → latest Sunday
export function defaultRange() {
  const to = latestSunday();
  return { from: new Date(to.getFullYear(), to.getMonth(), 1), to };
}

export function rangePresets() {
  const t = today();
  const sun = latestSunday();
  const mon = new Date(sun); mon.setDate(sun.getDate() - 6);
  return [
    { key: "mtd-sunday", label: "MTD to last Sun", ...defaultRange() },
    { key: "last-week", label: "Last week", from: mon, to: sun },
    { key: "mtd", label: "Month to date", from: new Date(t.getFullYear(), t.getMonth(), 1), to: t },
    { key: "last-month", label: "Last month", from: new Date(t.getFullYear(), t.getMonth() - 1, 1), to: new Date(t.getFullYear(), t.getMonth(), 0) },
  ];
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const fmt = (d, year) => `${d.getDate()} ${MONTHS[d.getMonth()]}${year ? ` ${d.getFullYear()}` : ""}`;

// e.g. "1 Oct – 18 Oct 2026 · Wk 40–42 · 18 days"
export function describeRange({ from, to }) {
  if (!from) return "Pick a start date";
  const end = to || from;
  const w1 = isoWeekOf(toYmd(from)).week;
  const w2 = isoWeekOf(toYmd(end)).week;
  const days = Math.round((end - from) / 86400000) + 1;
  return `${fmt(from)} – ${fmt(end, true)} · Wk ${w1 === w2 ? w1 : `${w1}–${w2}`} · ${days} day${days > 1 ? "s" : ""}`;
}
